import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = r((i, l) => /* @__PURE__ */ o.jsx(
  t,
  {
    ref: l,
    ...i,
    image: (s) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: [
          /* @__PURE__ */ o.jsx("g", { fill: "currentColor", clipPath: "url(#clip0_3410_69074)", children: /* @__PURE__ */ o.jsx("path", { d: "M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2v-2H3V3h2V1zM9.828 10.828 11.657 9H5V7h6.656L9.829 5.172l1.414-1.415 3.536 3.536a1 1 0 0 1 0 1.414l-3.536 3.536z" }) }),
          /* @__PURE__ */ o.jsx("defs", { children: /* @__PURE__ */ o.jsx("clipPath", { id: "clip0_3410_69074", children: /* @__PURE__ */ o.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
a.displayName = "LogoutIcon";
export {
  a as LogoutIcon,
  a as default
};
//# sourceMappingURL=index.js.map
